module.exports = {
      id: "black-arrow-usage",
      viewBox: "0 0 12 7",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#black-arrow",
      toString: function () {
        return this.url;
      }
    }